module.exports = __webpack_public_path__ + "media/application/images/svgs/paperclip-b6aeefd2139d3191bd0d3910f58d5108.svg";